// 简单的 i18n 模块：根据 wD-Language cookie 决定显示语言。
// 棋盘（React）界面所用文本的中文翻译。

const translations: Record<string, { en: string; zh: string }> = {
  "Game is finished.": { en: "Game is finished.", zh: "对局已结束。" },
  Power: { en: "Power", zh: "国家" },
  Centers: { en: "Centers", zh: "补给中心" },
  Status: { en: "Status", zh: "状态" },
  Bet: { en: "Bet", zh: "赌注" },
  Won: { en: "Won", zh: "赢得" },

  Spring: { en: "Spring", zh: "春季" },
  Autumn: { en: "Autumn", zh: "秋季" },
  Winter: { en: "Winter", zh: "冬季" },
  "Pre-game": { en: "Pre-game", zh: "对局开始前" },
  "Time Up": { en: "Time Up", zh: "时间到" },
  " remaining": { en: " remaining", zh: " 剩余" },
  d: { en: "d", zh: "天" },
  h: { en: "h", zh: "小时" },
  m: { en: "m", zh: "分" },
  s: { en: "s", zh: "秒" },
  Movement: { en: "Movement", zh: "移动" },
  Diplomacy: { en: "Diplomacy", zh: "外交" },
  Retreats: { en: "Retreats", zh: "撤退" },
  Builds: { en: "Builds", zh: "建造" },

  Move: { en: "Move", zh: "移动" },
  Hold: { en: "Hold", zh: "原地待命" },
  Convoy: { en: "Convoy", zh: "运输" },
  "Via Convoy": { en: "Via Convoy", zh: "经护航" },
  Support: { en: "Support", zh: "支援" },
  "Support Hold": { en: "Support Hold", zh: "支援驻守" },
  "Support Move": { en: "Support Move", zh: "支援移动" },
  Retreat: { en: "Retreat", zh: "撤退" },
  Build: { en: "Build", zh: "建造" },
  Disband: { en: "Disband", zh: "解散" },
  Army: { en: "Army", zh: "陆军" },
  Fleet: { en: "Fleet", zh: "舰队" },

  "Using the UI:": { en: "Using the UI:", zh: "界面操作说明：" },
  "Helpful information:": { en: "Helpful information:", zh: "实用信息：" },
  "Requesting help:": { en: "Requesting help:", zh: "寻求帮助：" },
  "Shortcut Key:": { en: "Shortcut Key:", zh: "快捷键：" },
  "Guide to points / scoring": {
    en: "Guide to points / scoring",
    zh: "积分 / 计分指南",
  },
  "Lodge a cheating suspicion": {
    en: "Lodge a cheating suspicion",
    zh: "举报作弊嫌疑",
  },

  Save: { en: "Save", zh: "保存" },
  Ready: { en: "Ready", zh: "就绪" },
  Unready: { en: "Unready", zh: "取消就绪" },
  "Readying...": { en: "Readying...", zh: "正在就绪…" },
  "Unreadying...": { en: "Unreadying...", zh: "正在取消就绪…" },
  "Saving...": { en: "Saving...", zh: "正在保存…" },
  Units: { en: "Units", zh: "单位" },
  Delays: { en: "Delays", zh: "延迟" },
  VOTED: { en: "VOTED", zh: "已投票" },
  "Game is paused.": { en: "Game is paused.", zh: "对局已暂停。" },
  "You failed to enter orders and had no excused absences.": {
    en: "You failed to enter orders and had no excused absences.",
    zh: "你未能提交命令，且没有豁免缺席。",
  },
  "You are in Civil Disorder": {
    en: "You are in Civil Disorder",
    zh: "你陷入内乱",
  },
  " and cannot rejoin due to a temp ban": {
    en: " and cannot rejoin due to a temp ban",
    zh: "，且因临时封禁无法重新加入",
  },
  "Rejoin Game": { en: "Rejoin Game", zh: "重新加入对局" },
  "Game progressed to a new phase...": {
    en: "Game progressed to a new phase...",
    zh: "对局进入新阶段……",
  },
  View: { en: "View", zh: "查看" },
  "Pre-game:": { en: "Pre-game:", zh: "对局开始前：" },
  "Game is waiting to start": {
    en: "Game is waiting to start",
    zh: "对局等待开始",
  },
  "Could not load game. You may need to join this game.": {
    en: "Could not load game. You may need to join this game.",
    zh: "无法加载对局，你可能需要先加入此对局。",
  },
  "via convoy": { en: "via convoy", zh: "经护航" },
  "retreats to": { en: "retreats to", zh: "撤退至" },
  disbands: { en: "disbands", zh: "解散" },
  Destroy: { en: "Destroy", zh: "解散" },
  "order unassigned": { en: "order unassigned", zh: "命令未分配" },
  "New phase": { en: "New phase", zh: "新阶段" },
  "No messages yet": { en: "No messages yet", zh: "暂无消息" },
  "Pick a country above and send the first message": {
    en: "Pick a country above and send the first message",
    zh: "选择上方国家，发送第一条消息",
  },
  "Next phase": { en: "Next phase", zh: "下一阶段" },
  "Jump to current phase": { en: "Jump to current phase", zh: "跳到当前阶段" },
  "Viewing an earlier phase - jump to the current phase to give orders": {
    en: "You are viewing an earlier phase. Jump to the current phase to give orders.",
    zh: "正在查看历史阶段，回到当前阶段才能下命令。",
  },
  "Auto-Save": { en: "Auto-Save", zh: "自动保存" },
  On: { en: "On", zh: "开启" },
  Off: { en: "Off", zh: "关闭" },
  "Automatically Save Game:": {
    en: "Automatically Save Game:",
    zh: "自动保存对局：",
  },
  "Select Unit (or territory), select Move, select Destination Territory.": {
    en: "Select Unit (or territory), select Move, select Destination Territory.",
    zh: "选择单位（或地区），选择移动，选择目标地区。",
  },
  "Select Army (or territory), select Convoy, select Destination Territory.": {
    en: "Select Army (or territory), select Convoy, select Destination Territory.",
    zh: "选择陆军（或地区），选择运输，选择目标地区。",
  },
  "Select Army (or territory), select Via Convoy, select Destination Territory.":
    {
      en: "Select Army (or territory), select Via Convoy, select Destination Territory.",
      zh: "选择陆军（或地区），选择经运输，选择目标地区。",
    },
  "Select Unit or territory, select Hold.": {
    en: "Select Unit or territory, select Hold.",
    zh: "选择单位或地区，选择原地待命。",
  },
  "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support.":
    {
      en: "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support.",
      zh: "选择支援单位（或地区），选择支援，选择要支援的单位（或地区）。",
    },
  "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support, select Destination Territory.":
    {
      en: "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support, select Destination Territory.",
      zh: "选择支援单位（或地区），选择支援，选择要支援的单位（或地区），选择目标地区。",
    },
  "Select Unit (or territory), select Retreat, select Destination Territory.": {
    en: "Select Unit (or territory), select Retreat, select Destination Territory.",
    zh: "选择单位（或地区），选择撤退，选择目标地区。",
  },
  "Select supply center territory, select type of unit (Army or Fleet).": {
    en: "Select supply center territory, select type of unit (Army or Fleet).",
    zh: "选择补给中心地区，选择单位类型（陆军或舰队）。",
  },
  Cancel: { en: "Cancel", zh: "取消" },
  Draw: { en: "Draw", zh: "平局" },
  Pause: { en: "Pause", zh: "暂停" },
  Unpause: { en: "Unpause", zh: "恢复" },
  PRESS: { en: "PRESS", zh: "消息" },
  ORDERS: { en: "ORDERS", zh: "命令" },
  INFO: { en: "INFO", zh: "信息" },
  "MY GAMES": { en: "MY GAMES", zh: "我的对局" },
  HELP: { en: "HELP", zh: "帮助" },
  CONTROL: { en: "CONTROL", zh: "控制" },
  on: { en: "on", zh: "开启" },
  off: { en: "off", zh: "关闭" },
  "auto save": { en: "auto save", zh: "自动保存" },
  complete: { en: "complete", zh: "完成" },
  "Orders ready": { en: "Orders ready", zh: "命令已就绪" },
  "select an order.": { en: "select an order.", zh: "选择一个命令。" },
  "no orders to fill for this phase.": {
    en: "no orders to fill for this phase.",
    zh: "本阶段无需填写命令。",
  },
  "build a unit.": { en: "build a unit.", zh: "建造一个单位。" },
  ", enter your orders.": {
    en: ", enter your orders.",
    zh: "，输入你的命令。",
  },
  " this phase": { en: " this phase", zh: " 本阶段" },
  PAUSED: { en: "PAUSED", zh: "已暂停" },

  // 开局前等待面板（WDPreGameWaiting）
  "Waiting for players": { en: "Waiting for players", zh: "等待玩家" },
  "Everyone has joined": {
    en: "Everyone has joined",
    zh: "全员到齐，即将开局",
  },
  "Waiting for": { en: "Waiting for", zh: "还差" },
  "more player": { en: "more player", zh: "名玩家" },
  "more players": { en: "more players", zh: "名玩家" },
  Starts: { en: "Starts", zh: "开局时间" },
  Seats: { en: "Seats", zh: "席位" },
  Open: { en: "Open", zh: "空位" },
  "(you)": { en: "(you)", zh: "（你）" },
  You: { en: "you", zh: "你" },
  Anonymous: { en: "Anonymous", zh: "匿名" },
  "Countries are assigned when the game starts.": {
    en: "Countries are assigned when the game starts.",
    zh: "国家在开局开始时随机分配。",
  },
  "Settings for this game": {
    en: "Settings for this game",
    zh: "本局设置",
  },
  "Phase length": { en: "Phase length", zh: "阶段时长" },
  "Bet to join": { en: "Bet to join", zh: "入局赌注" },
  minutes: { en: "minutes", zh: "分钟" },
  points: { en: "points", zh: "分" },
  None: { en: "None", zh: "无" },
  Press: { en: "Press", zh: "密码局" },
  "Draw type": { en: "Draw type", zh: "和局方式" },
  Yes: { en: "Yes", zh: "是" },
  No: { en: "No", zh: "否" },
  "Bring someone in": { en: "Bring someone in", zh: "邀请好友" },
  "Copy link": { en: "Copy link", zh: "复制链接" },
  Refresh: { en: "Refresh", zh: "刷新" },
  "My games": { en: "My games", zh: "我的对局" },

  // 人机对战：退出即销毁（WDInfoDisplay）
  "Bot game": { en: "Bot game", zh: "人机对战" },
  "Exit (destroy)": { en: "Exit (destroy)", zh: "退出（销毁）" },
  "Exit and destroy this bot game?": {
    en: "Exit and destroy this bot game?",
    zh: "退出并销毁这局人机对战？",
  },
  "Exit and destroy this sandbox game?": {
    en: "Exit and destroy this sandbox game?",
    zh: "退出并销毁这局沙盒对局？",
  },

  // 人机对战：命令就绪后的过回合倒计时（WDPhaseUI）
  "Next turn in": { en: "Next turn in", zh: "回合结算倒计时" },
  "Resolving turn...": { en: "Resolving turn...", zh: "正在结算回合…" },
  "Still resolving - try refreshing or exit the game": {
    en: "Still resolving - try refreshing or exit the game",
    zh: "结算超时：可刷新页面，或用「退出（销毁）」结束这局",
  },
  "No build site - your home supply centers are occupied": {
    en: "No build site - your home supply centers are occupied",
    zh: "无处建造：本国补给中心被占据（先在秋季把单位移出并守住补给中心）",
  },
  "Nothing to do this phase - resolving automatically": {
    en: "Nothing to do this phase - resolving automatically",
    zh: "本回合无需操作，正在自动结算…",
  },
};

let cachedLang: "en" | "zh" | null = null;

function detectLanguage(): "en" | "zh" {
  if (cachedLang) return cachedLang;
  if (typeof document !== "undefined") {
    const match = document.cookie.match(/(?:^|;\s*)wD-Language=([^;]+)/);
    cachedLang = match && match[1] === "Chinese" ? "zh" : "en";
  } else {
    cachedLang = "en";
  }
  return cachedLang;
}

export function t(key: string): string {
  const entry = translations[key];
  if (!entry) return key;
  return detectLanguage() === "zh" ? entry.zh : entry.en;
}

export default t;
